export const COLUMN_DATE = "10001";
export const COLUMN_TIME = "10002";
export const COLUMN_SITE = "10003";
export const COLUMN_TRANSACK_TYPE = "10004";
export const COLUMN_EVENT = "10005";
export const COLUMN_DIRECTION = "10006";
export const COLUMN_ZONE = "10007";
export const COLUMN_DOOR = "10008";
export const COLUMN_DEVICE = "10009";
export const COLUMN_UNIT_TYPE = "10010";
export const COLUMN_CONTROLLER = "10011";
export const COLUMN_NAME = "10012";
export const COLUMN_TAG_CODE = "10013";
export const COLUMN_TAG_TYPE = "10014";
export const COLUMN_COMPANY = "10015";
export const COLUMN_DEPARTMENT = "10016";
export const COLUMN_HOST = "10017";
export const COLUMN_OPEN_DOOR = "10018";
export const COLUMN_REASON_CODE = "10019";
export const COLUMN_TR_DATA = "10020";
export const COLUMN_INPUT_NAME = "10021";
export const COLUMN_TYPE = "10022";
export const COLUMN_AREA = "10023";
export const COLUMN_ATP = "10024";
export const COLUMN_FLOOR = "10025";
export const COLUMN_BUILDING = "10026";
export const COLUMN_PROFILE = "10027";
export const COLUMN_TIME_ZONE = "10028";
export const COLUMN_TIME_PATTERN = "10029";
export const COLUMN_ACTION_TYPE = "10030";
export const COLUMN_START_TIME = "10031";
export const COLUMN_END_TIME = "10032";
export const COLUMN_DURATION = "10033";
export const COLUMN_START_DATE = "10034";
export const COLUMN_END_DATE = "10035";
export const COLUMN_DAYS = "10036";
export const COLUMN_MON = "10037";
export const COLUMN_TUE = "10038";
export const COLUMN_WED = "10039";
export const COLUMN_THU = "10040";
export const COLUMN_FRI = "10041";
export const COLUMN_SAT = "10042";
export const COLUMN_SUN = "10043";
export const COLUMN_HOL = "10044";
export const COLUMN_FIRST_NAME = "10045";
export const COLUMN_LAST_NAME = "10046";
export const COLUMN_SECOND_NAME = "10047";
export const COLUMN_DISPLAY_NAME = "10048";
export const COLUMN_TITLE = "10049";
export const COLUMN_UNIQUE_IDENTIFIER = "10050";
export const COLUMN_EMAIL = "10051";
export const COLUMN_GENDER = "10052";
export const COLUMN_SUFFIX = "10053";
export const COLUMN_MAX_CAPACITY = "10054";
export const COLUMN_DURATION_WARNING = "10055";
export const COLUMN_DESCRIPTION = "10056";
export const COLUMN_ENTRY_READER = "10057";
export const COLUMN_EXIT_READER = "10058";
export const COLUMN_TAG_MASK = "10059";
export const COLUMN_SITE_MASK = "10060";
export const COLUMN_FIXED_ADDRESS = "10061";
export const COLUMN_IP_ADDRESS = "10062";
export const COLUMN_LOGICAL_ADDRESS = "10063";
export const COLUMN_SERIAL_ADDRESS = "10064";
export const COLUMN_CREDENTIALS = "10065";
export const COLUMN_STATUS = "10066";
export const COLUMN_EXPIRY_DATE = "10067";
export const COLUMN_USED_BY = "10068";
export const COLUMN_PORT_NUM = "10069";
export const COLUMN_QUEUE = "10070";
export const COLUMN_ENABLED = "10071";
export const COLUMN_DATE_LINKED = "10072";
export const COLUMN_ADDRESS = "10073";
export const COLUMN_DEVICE_DESCRIPTION = "10074";
export const COLUMN_DOOR_DESCRIPTION = "10075";
export const COLUMN_LEVEL = "10076";
export const COLUMN_SLOT = "10077";
export const COLUMN_CREATED_BY = "10078";
export const COLUMN_CODE = "10079";
export const COLUMN_HOST_IP = "10080";
export const COLUMN_ACCESS = "10081";
export const COLUMN_DATE_TIME = "10082";
export const COLUMN_READER = "10083";
export const COLUMN_CATEGORY = "10084";
export const COLUMN_PERMISSIONS = "10085";
export const COLUMN_ANTI_PASSBACK = "10086";
export const COLUMN_DOORS_COUNT = "10087";
export const COLUMN_ENROLMENTS_COUNT = "10088";
export const COLUMN_ZONES_COUNT = "10089";
export const COLUMN_LIFTS_COUNT = "10090";
export const COLUMN_FLOORS_COUNT = "10091";
export const COLUMN_LOGINS_COUNT = "10092";
export const COLUMN_INPUTS_COUNT = "10093";
export const COLUMN_READERS_COUNT = "10094";
export const COLUMN_CONTROLLERS_COUNT = "10095";
export const COLUMN_MODULES_COUNT = "10096";
export const COLUMN_ACCESS_GROUPS_COUNT = "10097";
export const COLUMN_CARDS_COUNT = "10098";
export const COLUMN_CARD_TYPES_COUNT = "10099";
export const COLUMN_ACTION = '10100';
export const COLUMN_COMMON_ZONE = '10101';
export const COLUMN_EXPIRED = '10102';
export const REPORTS_COLUMN_HOURS_WORKED = '16040';
export const REPORTS_COLUMN_HOURS_WORKED_TO_NOW = '16041';
export const COLUMN_OPERATOR = '16042';
export const COLUMN_FIELD = '16043';
export const COLUMN_DETAILS = '16044';
export const COLUMN_CONTACT_NUMBER = '10103';
export const COLUMN_BUTTON = '10104';
export const COLUMN_CLOCKING_EVENT = '10105';
export const COLUMN_EMAIL_SUBJECT = '10106';
export const COLUMN_FREQUENCY = '10107';
export const COLUMN_SEND_TO_RECIPIENTS = '10108';
export const COLUMN_ACCOUNT = '10109';
export const COLUMN_LICENSED = '10110';
export const COLUMN_USER_CHECK = '10111';
export const COLUMN_READER_SERIAL = '10112';
export const COLUMN_MUSTERING_POINT = '10113';
export const COLUMN_VERSION = "10114";
export const COLUMN_CERTIFICATE_AUTHORITY = '10115';
export const COLUMN_LAST_MODIFIED_BY = '10116';
export const COLUMN_CERTIFICATE_STATUS = '10117';
export const COLUMN_REVOKE = '10118';
export const COLUMN_USER_TYPE = '10119';
export const COLUMN_OSS_DEVICE_NAME = "10120";
export const COLUMN_OSS_DEVICE_ID = "10121";
export const COLUMN_OLD_VALUE = '10122';
export const COLUMN_NEW_VALUE = '10123';
export const COLUMN_SUB_TYPE = '10124';
export const COLUMN_AUDIT_ACTION_TYPE = '10125';
export const COLUMN_SHIFT_TYPE = '10126';
export const COLUMN_DAYS_WORKED = '10127';
export const COLUMN_TOTAL_HOURS_WORKED = '10128';
export const COLUMN_AVG_HOURS_PER_DAY = '10129';
export const COLUMN_AVG_FIRST_IN_TIME = '10130';
export const COLUMN_AVG_LAST_OUT_TIME = '10131';
export const COLUMN_FIRST_IN = '10132';
export const COLUMN_LAST_OUT = '10133';
export const COLUMN_TIME_SPAN = '10134';
export const COLUMN_SEGMENTS = '10135';
export const COLUMN_NOTES = '10136';
export const COLUMN_LAST_USED_DATE = '10137';
export const COLUMN_DAYS_INACTIVE = '10138';
export const COLUMN_ACCESS_GROUP = '10139';
export const COLUMN_ACCESS_GROUP_SITE = '10140';
export const COLUMN_EXPIRY_REASON = '10141';
export const COLUMN_CLOSEST_EXPIRY_DAYS = '10142';